// extracted by mini-css-extract-plugin
module.exports = {"list":"bulleted-list_list__ffsr_","listDense":"bulleted-list_listDense__wq1CB"};